export const selectData = [
  {
    id: 1,
    placeholder: "Show",
    options: [
      { value: "orders", label: "Orders" },
      { value: "drivers", label: "Drivers" },
    ],
  },
  {
    id: 2,
    placeholder: "Delivery Within",
    options: [
      { value: "1 Hour", label: "1 Hour" },
      { value: "2 Hours", label: "2 Hours" },
      { value: "3 Hours", label: "3 Hours" },
      { value: "4 Hours", label: "4 Hours" },
      { value: "5 Hours", label: "5 Hours" },
      { value: "6 Hours", label: "6 Hours" },
      { value: "7 Hours", label: "7 Hours" },
      { value: "8 Hours", label: "8 Hours" },
      { value: "9 Hours", label: "9 Hours" },
      { value: "10 Hours", label: "10 Hours" },
      { value: "11 Hours", label: "11 Hours" },
      { value: "12 Hours", label: "12 Hours" },
    ],
  },
  {
    id: 3,
    placeholder: "Delivery Status",
    options: [
      { value: "active", label: "Active" },
      { value: "accepted", label: "Accepted" },
      { value: "rejected", label: "Rejected" },
      { value: "cancelled", label: "Cancelled" },
      { value: "delivered", label: "Delivered" },
    ],
  },
  {
    id: 4,
    placeholder: "Driver Status",
    options: [
      { value: "free", label: "Free" },
      { value: "busy", label: "Busy" },
      { value: "offline", label: "Offline" },
    ],
  },
  {
    id: 5,
    placeholder: "Request Accepted By",
    options: [
      { value: "driver", label: "Driver" },
      { value: "admin", label: "Admin" },
    ],
  },
];

export const markers = {
  drivers: [
    {
      id: "1",
      name: "driver1",
      lat: 24.7136,
      lng: 46.6753,
      status: "available",
      marker:
        "https://maps.google.com/mapfiles/kml/shapes/parking_lot_maps.png",
      orders: [],
    },
    {
      id: "2",
      name: "driver2",
      lat: 24.7489,
      lng: 46.6387,
      status: "busy",
      marker:
        "https://maps.google.com/mapfiles/kml/shapes/parking_lot_maps.png",
      orders: [
        {
          id: "1",
          name: "order1",
          lat: "1.1",
          lng: "1.1",
          marker:
            "https://maps.google.com/mapfiles/kml/shapes/parking_lot_maps.png",
        },
      ],
    },
    {
      id: "3",
      name: "driver3",
      lat: 24.7136,
      lng: 46.6753,
      status: "offline",
      marker:
        "https://maps.google.com/mapfiles/kml/shapes/parking_lot_maps.png",
      orders: [],
    },
  ],
  orders: [
    {
      id: "1",
      name: "order1",
      lat: "1.1",
      lng: "1.1",
      scheduled_at: "2021-05-01 12:00:00",
      marker:
        "https://maps.google.com/mapfiles/kml/shapes/parking_lot_maps.png",
      driver: {
        id: "1",
        name: "driver1",
        lat: "1.1",
        lng: "1.1",
        status: "available",
        marker:
          "https://maps.google.com/mapfiles/kml/shapes/parking_lot_maps.png",
      },
      status: "pending",
    },
    {
      id: "2",
      name: "order2",
      lat: "1.1",
      lng: "1.1",
      scheduled_at: "2021-05-01 12:00:00",
      marker:
        "https://maps.google.com/mapfiles/kml/shapes/parking_lot_maps.png",
      driver: {
        id: "2",
        name: "driver2",
        lat: "1.1",
        lng: "1.1",
        status: "busy",
        marker:
          "https://maps.google.com/mapfiles/kml/shapes/parking_lot_maps.png",
      },
      status: "pending",
    },
  ],
};
